function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Livello_2",
  "data-name": "Livello 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Livello_1-2",
  "data-name": "Livello 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30,0H5.91A5.92,5.92,0,0,0,0,5.91V30a5.92,5.92,0,0,0,5.91,5.91H30A5.92,5.92,0,0,0,35.89,30V5.91A5.92,5.92,0,0,0,30,0Zm3.15,30A3.16,3.16,0,0,1,30,33.13H5.91A3.16,3.16,0,0,1,2.76,30V5.91A3.15,3.15,0,0,1,5.91,2.76H30a3.16,3.16,0,0,1,3.15,3.15Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.94,23.46a1.39,1.39,0,1,0,1.38,1.38A1.38,1.38,0,0,0,17.94,23.46Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.94,8.28a5,5,0,0,0-4.91,4,4.85,4.85,0,0,0-.1,1.07,1,1,0,0,0,1,1A1,1,0,0,0,15,13.4a4.93,4.93,0,0,1,.3-1.34A2.93,2.93,0,0,1,20,11.15a2.49,2.49,0,0,1,.14,3.77l-.51.48c-.51.44-1,.87-1.52,1.34a3.37,3.37,0,0,0-1.16,2.67h0c0,.14,0,.4,0,.54a1,1,0,0,0,1,1,1,1,0,0,0,1-1c0-.1,0-.27,0-.39a1.77,1.77,0,0,1,.65-1.44c.68-.6,1.38-1.18,2-1.81a4.14,4.14,0,0,0,1.23-4.06A5,5,0,0,0,17.94,8.28Z"
})));

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.89 35.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.69cc2c87.svg";
export { ForwardRef as ReactComponent };